import { render, staticRenderFns } from "./r-treasure-piece-config-dialog.vue?vue&type=template&id=1fedce10&scoped=true"
import script from "./r-treasure-piece-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-treasure-piece-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-treasure-piece-config-dialog.vue?vue&type=style&index=0&id=1fedce10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fedce10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fedce10')) {
      api.createRecord('1fedce10', component.options)
    } else {
      api.reload('1fedce10', component.options)
    }
    module.hot.accept("./r-treasure-piece-config-dialog.vue?vue&type=template&id=1fedce10&scoped=true", function () {
      api.rerender('1fedce10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-piece-config-dialog.vue"
export default component.exports